module.exports = __webpack_public_path__ + "static/img/lodding.97b4e1c.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/lodding.gif
// module id = Fdiv
// module chunks = 1